<!-- 
  新建 回款计划
  props:
    modal: 是否开启弹窗遮罩
    initData: 初始数据
  emit: 
    refresh: 提交刷新列表请求
 -->

<template>
  <div class="pay-plan">
    <el-dialog title="新建回款计划" 
      :visible.sync="dialogVisible" 
      :modal="modal"
      width="700px"
      >
      <div class="content">
        <el-form class="addnew-from">
          <el-form-item
            label="客户名称"
            label-width="120px">
            <div class="item-select" :class="{disable: customerId&&customerId.nonEditable === 1}">
              <el-autocomplete
                v-if="!customerId.id"
                v-model="itemValueCustomer"
                :fetch-suggestions="(queryString, cb) => querySearchAsync(queryString, cb, 'customer')"
                placeholder="请输入名称搜索或点击“选择”添加"
                @select="item => selectedChecked(item, 'customer')"
              ></el-autocomplete>

              <span class="item" v-if="customerId.id">
                <span class="text">{{customerId.value}}</span>
                <i class="del el-icon-close" @click="del(1)"></i>
              </span>    
              <el-button type="text" class="select-btn" @click="handleSelect('customerApi')">选择</el-button>              
            </div>           
          </el-form-item >
          <el-form-item
            v-if="customerId&&customerId.id"
            label="合同名称"
            label-width="120px">
            <div class="item-select" :class="{disable: contractId&&contractId.nonEditable === 1}">
              <el-autocomplete
                v-if="contractId && !contractId.id"
                v-model="itemValueContract"
                :fetch-suggestions="(queryString, cb) => querySearchAsync(queryString, cb, 'contract')"
                placeholder="请输入名称搜索或点击“选择”添加"
                @select="item => selectedChecked(item, 'contract')"
              ></el-autocomplete>

              <span class="item" v-if="contractId && contractId.id">
                <span class="text">{{contractId.value}}</span>
                <i class="del el-icon-close" @click="del(2)"></i>
              </span>    
              <el-button type="text" class="select-btn" @click="handleSelect('contractApi')">选择</el-button>            
            </div>
          </el-form-item>
          <el-form-item
            v-if="customerId && customerId.id && contractId && contractId.id"
            label="回款计划"
            label-width="120px">
            <payment-box
              v-if="isToggleContract"
              ref="paymentBox"
              :moduleName="'payment'"
              :contractId="contractId.id || 0"
            >
            </payment-box>       
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <div class="v-modal" style="z-index: 100" v-if="!modal && dialogVisible"></div>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message } from 'element-ui'
import { mapGetters, mapActions } from 'vuex'
import paymentBox from 'components/fieldtype/payment/index'
import remoteSelect from 'components/fieldtype/remote-select'

export default {
  props: {
    modal: {
      type: Boolean,
      default: true
    },
    initData: {
      type: Object
    }
  },
  data () {
    return {
      customerId: {},
      contractId: {},
      dialogVisible: false,
      opUUID: '',
      itemValueCustomer: '',
      itemValueContract: '',
      timeout: null,
      isToggleContract: false
    }
  },
  computed: {
    ...mapGetters([
      'paymentForm',
      'editPaymentData',
      'addPaymentData'
    ])
  },
  created () {
    this.makeopUUID()
    let str = 'payment-item'
    this.setPaymentType(str)
    if (this.initData) {
      this.customerId = this.initData.customer || {}
      this.contractId = this.initData.contract || {}
      this.isToggleContract = true
    }
  },
  methods: {
    ...mapActions([
      'checkPayment',
      'setPaymentType'
    ]),
    // 根据时间戳生成hash
    makeopUUID () {
      let d = new Date()
      this.opUUID = d.getTime()
    },
    // 保存已选数据
    dateSave (arr, module) {
      if (module === 'customerApi') {
        if (arr[0]) {
          this.customerId = arr[0]
          this.contractId = {}
          this.isToggleContract = false
        } else {
          this.customerId = {}
          this.contractId = {}
        }
      } else {
        if (arr[0]) {
          this.contractId = arr[0]
          this.isToggleContract = true
        } else {
          this.contractId = {}
        }
      }
    },
    handleSubmit () {
      // 对回款计划进行验证
      this.checkPayment(true)
      this.$nextTick(() => {
        let len = this.editPaymentData.length + this.addPaymentData.length
        if (this.paymentForm.length === len) {
          this.savePayment()
        } else {
          this.checkPayment(false)
        }
      })
    },
    // 表单保存
    savePayment () {
      const url = '/paymentApi/save.html'
      const params = {
        defaultData: {
          contractId: this.contractId.id,
          payment: this.paymentForm
        },
        opUUID: this.opUUID
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: data.isApprovalMsg || data.msg || '保存成功！',
          duration: 1000
        })
        this.$emit('closeDialog')
        this.makeopUUID() // 重置时间戳
      })
      this.checkPayment(false)
    },
    del (type) {
      if (type === 1) {
        this.customerId = {}
        this.itemValueCustomer = ''
      }
      this.contractId = {}
      this.itemValueContract = ''
      this.$emit('cleanAttr')
    },
    handleSelect (type) {
      let data = []
      this.isToggleContract = false
      if (type === 'customerApi') {
        data = this.customerId.id ? [this.customerId] : []
      } else {
        data = this.contractId.id ? [this.contractId] : []
      }
      this.$emit('handleSelect', type, data)
    },
    querySearchAsync (queryString, cb, type) {
      clearTimeout(this.timeout)
      queryString = queryString.trim()
      if (!queryString) {
        cb([])
        return
      }
      this.timeout = setTimeout(() => {
        let params = {
          nameLike: queryString
        }
        let url = ''
        if (type === 'customer') {
          url = '/customerApi/getCustomers.html'
        } else {
          url = '/contractApi/getContractList.html'
          params.customerId = this.customerId.id
        }
        api.post(url, params, (data) => {
          cb(data.result)
        })
      }, 3000 * Math.random())
    },
    selectedChecked (item, type) {
      if (type === 'customer') {
        this.customerId = {
          id: item.id,
          value: item.value
        }
        this.contractId = {}
      } else {
        this.contractId = {
          id: item.id,
          value: item.value
        }
        this.isToggleContract = true
      }
    }
  },
  watch: {
    dialogVisible () {
      if (this.dialogVisible === false && !this.initData) {
        this.customerId = {}
      }
    },
    customerId () {
      this.$emit('customerIdChange', this.customerId)
    }
  },
  components: {
    paymentBox,
    remoteSelect
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable.less";
.order {
  border: 1px dashed #d8d8d8;
  border-radius: 2px;
  padding: 15px;
  .title {
    height: 28px;
    color: @bg-orange;
    font-size: 15px;
    .small {
      font-size: 13px;
    }
  }
  .order-infos {
    margin-bottom: 26px;
    font-size: 0;
    .item {
      display: inline-block;
      width: 50%;
      font-size: 13px;
      .orange {
        color: @bg-orange;
      }
    }
  }
  .pay-infos {
    margin-bottom: 26px;
  }
}
</style>
<style lang="less" scoped>
@import "../../../assets/less/remote-select.less";
.addnew-from {
  margin-right: 50px;
}
.item-select {
  .el-autocomplete {
    width: 100%;
  }
  .detail-bg {
    top: 0;
  }
  &.disable {
    background-color: #eef1f6;
    border: 1px solid #d1dbe5;
    color: #bbb;
    &:after {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      opacity: 0;
      cursor: not-allowed;
    }
  }
}
.repeat-list {
  position: absolute;
  width: 250px;
  max-height: 300px;
  background-color: #fff;
  z-index: 100;
  overflow: auto;
  box-shadow: 0 0 4px 0 rgba(137, 137, 137, 0.5);
  left: 2px;
  top: 40px;
  .title {
    font-size: 14px;
    line-height: 32px;
    border-bottom: 1px solid #ededed;
    padding-left: 10px;
  }
  .repeat-item {
    cursor: pointer;
    line-height: 28px;
    padding: 0 10px;
    color: #888;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>


// WEBPACK FOOTER //
// add-payment.vue?71aeaad3